

import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import successSvg from "../assets/svg/paymet-success.svg"
import failedSvg from "../assets/svg/server_down.svg"

export default function PaymentStatus({ status }) {
  // document.body.classList.remove("sidebar-show");
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';

      const [skin, setSkin] = useState(currentSkin);
    
      const switchSkin = (skin) => {
        if (skin === 'dark') {
          const btnWhite = document.getElementsByClassName('btn-white');
    
          for (const btn of btnWhite) {
            btn.classList.add('btn-outline-primary');
            btn.classList.remove('btn-white');
          }
        } else {
          const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');
    
          for (const btn of btnOutlinePrimary) {
            btn.classList.remove('btn-outline-primary');
            btn.classList.add('btn-white');
          }
        }
      };
    
      switchSkin(skin);
      useEffect(() => {
        switchSkin(skin);
      }, [skin])

  const config = {
    success: {
      title: "Payment Successful!",
      subtitle: "Thank you for your purchase",
      message: "Your payment has been processed successfully. You will receive a confirmation email shortly.",
      icon: "ri-checkbox-circle-fill",
      image: successSvg,
      buttonText: "Back to Dashboard",
      buttonVariant: "primary",
      textColor: "text-success"
    },
    failed: {
      title: "Payment Failed",
      subtitle: "We couldn't process your payment",
      message: "There was an issue processing your payment. Please try again or use a different payment method.",
      icon: "ri-error-warning-fill",
      image: failedSvg,
      buttonText: "Try Again",
      buttonVariant: "outline-primary",
      textColor: "text-danger"
    }
  };

  const currentConfig = config[status];

  return (
    <div className="page-error man
    ">
      {/* Header */}
      <div className="header py-3 border-bottom">
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            <Link to="/" className="header-logo text-decoration-none fs-3 fw-bold text-dark">
              Deda
            </Link>
            <Nav className="nav-icon">
              <Nav.Link href="" className="text-muted">
                <i className="ri-twitter-fill"></i>
              </Nav.Link>
              <Nav.Link href="" className="text-muted">
                <i className="ri-github-fill"></i>
              </Nav.Link>
              <Nav.Link href="" className="text-muted">
                <i className="ri-dribbble-line"></i>
              </Nav.Link>
            </Nav>
          </div>
        </Container>
      </div>

      {/* Main Content */}
      <div className="content flex-grow-1 d-flex align-items-center justify-content-center py-5">
        <Container>
          <Row className="gx-5 align-items-center justify-content-center">
            <Col lg="5" className="text-center text-lg-start">
              <div className="mb-4">
                <i className={`${currentConfig.icon} ${currentConfig.textColor} display-1`}></i>
              </div>
              <h1 className={`display-5 fw-bold mb-3 ${currentConfig.textColor}`}>
                {currentConfig.title}
              </h1>
              <h3 className="text-muted mb-4">{currentConfig.subtitle}</h3>
              <p className="lead text-muted mb-4">
                {currentConfig.message}
              </p>
              
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start">
                <Link 
                  to="/dashboard/overview" 
                  className={`btn btn-${currentConfig.buttonVariant} btn-lg px-4`}
                >
                  {currentConfig.buttonText}
                </Link>
                {status === "failed" && (
                  <Link 
                    to="/checkout" 
                    className="btn btn-outline-secondary btn-lg px-4"
                  >
                    Try Different Payment
                  </Link>
                )}
              </div>

              {/* Additional Info */}
              <div className="mt-5 pt-3 border-top">
                <p className="text-muted small mb-2">Need help with your payment?</p>
                <Link to="/support" className="text-decoration-none">
                  Contact Support <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </Col>
            
            <Col lg="6" className="text-center mt-5 mt-lg-0">
              <img 
                src={currentConfig.image} 
                alt={`Payment ${status}`}
                className="img-fluid w-75"
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Footer */}
      <div className="footer py-4 bg-light mt-auto">
        <Container>
          <div className="text-center text-muted">
            <p className="mb-0 small">
              © 2024 Deda. All rights reserved. 
              <Link to="/privacy" className="text-decoration-none ms-2">Privacy Policy</Link>
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
}